import React from 'react'
// import {HiArrowRight} from "react-icons/hi";
const Card = ({title, des, icon, link}) => {
  return (
    <div className="w-full px-12 h-80 py10 rounded-lg shadow-shadowOne flex items-center
    bg-gradient-to-r hover:from-black hover:to-[#1e2024] transition-colors
    duration-1000 group">
  <div className="h-72 overflow-y-hidden">
   <div className="flex  h-full flex-col gap-3 translate-y-9 group-hover:translate-y-0 transition-trabsform duration-500 " >
       <div>
           <span className="text-3xl text-designColor">{icon}</span> 
        </div>
        <div className='flex flex-col gap-4'>
            <h2 className="text-xl md:text-2xl font-titleFont text-gray-300">
            {title}
            </h2>
           <p className="base ">{des}  </p>  
           <p className="hover:text-designColor ml-[70px]">{link}</p>
           {/* <span className="text-2xl text-designColor">
           <HiArrowRight/>
            </span>     */}
         </div>


   </div>
  </div>
    </div>
  )
}

export default Card